import { render, staticRenderFns } from "./ClientsList.vue?vue&type=template&id=bbcd999c&scoped=true"
import script from "./ClientsList.vue?vue&type=script&lang=ts"
export * from "./ClientsList.vue?vue&type=script&lang=ts"
import style0 from "./ClientsList.vue?vue&type=style&index=0&id=bbcd999c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcd999c",
  null
  
)

export default component.exports